import config from "@/config"
import http from "@/utils/request"

// 抽奖中奖记录（文件名即一级分组：$API.lotteryRecord.xxx）
export default {
	// 中奖记录列表（分页，支持活动/类型/用户/时间筛选）
	index: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/record/index`,
		name: "中奖记录列表",
		get: async function(data={}){
			return await http.get(this.url, data);
		}
	},
	// 实物奖品发货/备注处理
	deliver: {
		url: `${config.API_URL}/bwmall/admin/activity/lottery/record/deliver`,
		name: "中奖发货处理",
		post: async function(data={}){
			return await http.post(this.url, data);
		}
	}
}
